<div class="recovery">
  <div class="recovery__wrapper">
    <picture>
      <img src="../assets/images/Linkerweb_LogoFull_01.png" class="recovery__logo" alt="Logo" />
    </picture>

    <h1 class="recovery__title">¿Olvidaste tu contraseña?</h1>

    <p class="recovery__description">
      Para restablecer tu contraseña, introduce tu nombre de usuario y la dirección de email asociada a tu cuenta.
    </p>

    <form [formGroup]="form" (submit)="resetPassword()" class="recovery__form">
      <div class="recovery__field">
        <label for="username" class="recovery__label">Usuario</label>
        <input
          formControlName="username"
          id="username"
          type="text"
          placeholder="Introduce tu usuario"
          class="recovery__input"
        />
        @if (form.get('username')?.touched && form.get('username')?.invalid) {
          <small class="recovery__error">Introduce un usuario de al menos 3 caracteres.</small>
        }
      </div>

      <div class="recovery__field">
        <label for="email" class="recovery__label">Correo</label>
        <input
          formControlName="email"
          id="email"
          type="email"
          placeholder="Introduce tu correo"
          class="recovery__input"
        />
        @if (form.get('email')?.touched && form.get('email')?.invalid) {
          <small class="recovery__error">Introduce una dirección de correo válida.</small>
        }
      </div>

      <button type="submit" class="recovery__submit" [disabled]="!form.valid">Restablecer mi contraseña</button>

      <a class="recovery__back" routerLink="/login">¿Ya la recuperaste? Iniciar sesión</a>
    </form>
  </div>

  <picture>
    <img src="../assets/images/login-background.png" class="recovery__illustration" alt="Ilustración" />
  </picture>

  <picture>
    <img src="../assets/images/lnnova-links-dark.png" class="recovery__brand" alt="Logo Innovalinks" />
  </picture>
</div>
